import {Injectable} from '@angular/core';
import {AuthenticationService} from '../authentication/authentication.service';
import {Router} from '@angular/router';
import {USER_ROLES} from '../../constants/roles/roles.const';

@Injectable({
    providedIn: 'root'
})
export class PermissionService {

    constructor(
        private authService: AuthenticationService,
        private router: Router
    ) {
    }

    routerGuard() {
        if (this.authService.hasRole([USER_ROLES.Doctor])) {
            return true
        }

        if (this.authService.hasRole([USER_ROLES.Patient])) {
            return true
        }

        return true
    }

    roleGuard(role: string[]) {
        return !!(this.authService.isAuthenticated() && this.authService.hasRole(role))
    }
}
